// Custom Code
$(document).ready(function () {
    /* ### NWH Image Links Section - Dropdown Toggle ### */
    $(".js-nwh-btn--linklist").click(function () {
        $(".nwh-home-image-links__linklist")
            .not($(this).parent())
            .removeClass("nwh-home-image-links__linklist--active");
        $(this).parent().toggleClass("nwh-home-image-links__linklist--active");
    });/* ### NWH Image Links Section - Dropdown Toggle ### */
});


